angular.module('percentCouponsAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/percent-coupons-add/percent-coupons-add.module.js